import { Image as ImageA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icons';
import { Paragraph } from '../typography';

import styles from './image.module.css';

export type ImageProperties = {
  borderRadius?: 'large' | 'small';
  layout?: 'fluid-image';
  objectFit?: 'cover';
  size?: ImageSize;
  type?: ImageType;
} & ComponentProps<typeof ImageA>;

export type ImageSize = 'extra-large' | 'large' | 'middle' | 'small';

type ImageType = 'rounded';

const { PreviewGroup } = ImageA;

// TODO: check if sizes working right
const Image = ({
  alt,
  borderRadius,
  className,
  layout,
  objectFit,
  preview = true,
  rootClassName,
  size,
  type,
  ...rest
}: ImageProperties) => {
  const { t } = useTranslation();

  return (
    <ImageA
      alt={alt ? t(alt) : undefined}
      className={cn(className, {
        [styles.large ?? '']: size === 'large',
        [styles.middle ?? '']: size === 'middle',
        [styles.rounded ?? '']: type === 'rounded',
        [styles.small ?? '']: size === 'small',
        [styles['border-radius-large'] ?? '']: borderRadius === 'large',
        [styles['border-radius-small'] ?? '']: borderRadius === 'small',
        [styles['extra-large'] ?? '']: size === 'extra-large',
        [styles['object-fit-cover'] ?? '']: objectFit === 'cover',
      })}
      preview={
        preview
          ? {
              mask: (
                <Paragraph ellipsis type="light">
                  <Image.PreviewIcon /> Preview
                </Paragraph>
              ),
              ...(typeof preview === 'object' && preview),
            }
          : false
      }
      rootClassName={cn(rootClassName, {
        [styles['wrapper--fluid'] ?? '']: layout === 'fluid-image',
      })}
      {...rest}
    />
  );
};

const PreviewIcon = () => <Icon icon="eye-2-line" />;

Image.PreviewGroup = PreviewGroup;
Image.PreviewIcon = PreviewIcon;

export default Image;
